import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Pow Wow Finder';
const SITE_URL = 'https://powwowfinder.com';
const DEFAULT_DESC =
  'Discover Native American & First Nations pow wows across Turtle Island. Interactive map, event details, trip planner. Find. Plan. Celebrate. Honor.';
const DEFAULT_IMAGE = `${SITE_URL}/logo.png`;

/**
 * Universal SEO component. Injects unique title, description, canonical,
 * Open Graph (Facebook / iMessage previews), Twitter cards, and optional
 * JSON-LD structured data for every route.
 */
export default function Seo({
  title,
  description = DEFAULT_DESC,
  image = DEFAULT_IMAGE,
  path = '',
  type = 'website',
  jsonLd = null,
  keywords = 'pow wow, powwow, native american, first nations, indigenous events, tribal gathering, powwow calendar, powwow near me',
  noindex = false,
}) {
  const fullTitle = title
    ? `${title} — ${SITE_NAME}`
    : `${SITE_NAME} — Find · Plan · Celebrate · Honor`;
  const canonical = `${SITE_URL}${path || ''}`;
  const absImage = image?.startsWith('http') ? image : `${SITE_URL}${image || DEFAULT_IMAGE}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={absImage} />
      <meta property="og:image:alt" content={title || SITE_NAME} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absImage} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(Array.isArray(jsonLd) ? jsonLd : [jsonLd])}
        </script>
      )}
    </Helmet>
  );
}
